// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import config from 'config';

import appLogoSports from 'assets/images/CBS_sports_logo.png';
import appLogoNews from 'assets/images/CBS_news_logo.png';

import styles from './LogoPage.module.scss';

const LogoPage = ({ className, background, hideLogo, children }) => {
  return (
    <div
      className={classNames(
        'w-100 h-100',
        styles.page,
        {
          [styles.gradient]: background === 'gradient',
          [styles.opaque]: background === 'opaque',
        },
        className,
      )}
    >
      <img
        alt="App Logo"
        src={config.buildBrandId === 'cbs-news' ? appLogoNews : appLogoSports}
        className={classNames(styles.logo, {
          'd-block': !hideLogo,
          'd-none': hideLogo,
        })}
      />
      {children}
    </div>
  );
};

LogoPage.propTypes = {
  background: PropTypes.oneOf(['transparent', 'gradient', 'opaque']),
  children: PropTypes.node,
  className: PropTypes.string,
  hideLogo: PropTypes.bool,
};

LogoPage.defaultProps = {
  background: 'gradient',
  children: null,
  className: null,
  hideLogo: false,
};

export default LogoPage;
